import { useState, useRef, useEffect } from "react";
import { useLocation } from "wouter";
import { trpc } from "@/lib/trpc";

// Lupa global de posts/tarefas (pedido João ago/26). Busca por título ou
// content_id nos clientes que o usuário enxerga (Raz = todos). Clicar num
// resultado navega pra /c/:key → troca o cliente ativo e abre o card.
export default function GlobalSearch({ isRaz, onNavigate }: { isRaz: boolean; onNavigate?: () => void }) {
  const [, navigate] = useLocation();
  const [q, setQ] = useState("");
  const [deb, setDeb] = useState("");
  const [open, setOpen] = useState(false);
  const boxRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const t = setTimeout(() => setDeb(q.trim()), 250);
    return () => clearTimeout(t);
  }, [q]);

  const { data: results = [], isFetching } = trpc.pautas.search.useQuery(
    { q: deb }, { enabled: deb.length >= 2, staleTime: 30_000 }
  );

  useEffect(() => {
    const h = (e: MouseEvent) => {
      if (boxRef.current && !boxRef.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const go = (r: { id: number; contentId: string | null }) => {
    setOpen(false); setQ(""); setDeb("");
    onNavigate?.();
    navigate(`/c/${r.contentId || r.id}`);
  };

  return (
    <div ref={boxRef} className="relative px-3 pt-2 pb-1">
      <div className="relative">
        <svg className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[var(--solar-mute)] pointer-events-none"
             fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z" />
        </svg>
        <input
          value={q}
          onChange={e => { setQ(e.target.value); setOpen(true); }}
          onFocus={() => setOpen(true)}
          onKeyDown={e => { if (e.key === "Escape") { setOpen(false); (e.target as HTMLInputElement).blur(); } }}
          placeholder="Buscar posts…"
          className="w-full pl-9 pr-3 py-2 rounded-xl text-[13px] bg-[var(--sidebar-accent)] text-[var(--solar-ink)] placeholder:text-[var(--solar-mute)] border border-transparent focus:border-[var(--solar-line)] focus:outline-none"
        />
      </div>
      {open && deb.length >= 2 && (
        <div className="absolute left-3 right-3 top-full mt-1 z-50 rounded-xl border border-[var(--solar-line)] bg-[var(--solar-card)] shadow-lg max-h-[60vh] overflow-y-auto">
          {isFetching && !results.length && (
            <div className="px-3 py-3 text-[12px] text-[var(--solar-mute)]">Buscando…</div>
          )}
          {!isFetching && !results.length && (
            <div className="px-3 py-3 text-[12px] text-[var(--solar-mute)]">Nada encontrado.</div>
          )}
          {results.map(r => (
            <button
              key={r.id}
              onClick={() => go(r)}
              className="w-full text-left px-3 py-2 hover:bg-[var(--sidebar-accent)] transition-colors border-b border-[var(--solar-line)] last:border-0"
            >
              <div className="text-[13px] text-[var(--solar-ink)] font-medium truncate">{r.titulo}</div>
              <div className="text-[11px] text-[var(--solar-mute)] flex items-center gap-1.5 mt-0.5">
                {isRaz && r.clientNome && (<><span className="truncate max-w-[45%]">{r.clientNome}</span><span>·</span></>)}
                <span>{(r as any).colunaLabel ?? r.coluna}{(r as any).foraDoQuadro ? " (fora do quadro)" : ""}</span>
                {isRaz && r.contentId && (<><span>·</span><span className="font-mono">{r.contentId}</span></>)}
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
